import DealTable from "./DealTable";

export default DealTable;
